import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class OnKeyDown extends Component {
  static propTypes = {
    onKeyDown: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.setWrapperRef = this.setWrapperRef.bind(this)
  }

  setWrapperRef(ref) {
    if (ref !== null) {
      this.container = ref
    }
  }

  render() {
    const { children, ...props } = this.props
    return (
      <div {...props} ref={this.setWrapperRef}>
        {children}
      </div>
    )
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handle, true)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handle, true)
  }

  handle = e => {
    const { onKeyDown } = this.props
    const el = this.container
    if (!el.contains(e.target)) onKeyDown(e)
  }
}



// WEBPACK FOOTER //
// ./client/components/onKeyDown.js